<div class="page-section">
	<div class="page-heading-details-section">
		<div class="page-heading-section">
			<img src="assets/back.png" class="page-back-icon" (click)="back()" />
			<!-- <span>{{type}}({{total_count}})</span> -->
			<!-- <span>{{type}}({{commonService.formatNumberWithCommas(total_count)}})</span> -->
			<span>{{type}}({{total_count | number:'1.0-0'}})</span>
			<div class="section-heading-tooltip-block">
				<img src="assets/info-black.png" />
				<div class="section-heading-tooltip-section" style="width: 480px;">
					<div class="module-page-information-section" *ngFor="let section of description_sections">
						<div class="each-module-page-information-section">
							<p class="each-module-page-information-heading">{{section.name}}</p>
						</div>
						<ng-container *ngIf="section.sub_sections">
							<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
								<div class="each-module-page-information-sub-section">
									<p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
									<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>

									<ng-container *ngIf="sub_section.sub_sections">
										<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
											<p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
											<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
										</div>
									</ng-container>

								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
		<div>
			<!-- <button class="funnel-button" (click)="openAgenticFlow()" *ngIf="stepper_details_loaded">View Agentic Flow</button> -->
			<button class="funnel-button" (click)="openAgenticFlow()" *ngIf="stepper_details_loaded">View Agentic AI Workflow</button>
			<button class="funnel-button" (click)="openSalesFunnelModal()" *ngIf="stepper_details_loaded">View Sales Funnel</button>
		</div>
	</div>

	<div class="page-tabs-section" *ngIf="type != 'Bank Customers to Investment Clients' && type != 'New Prospects'">
    <!-- <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == user_details.role.role_name + ' Managed' }" (click)="tabChange(user_details.role.role_name + ' Managed')" >
        <span>{{user_details.role.role_name}} Managed ({{(tab_details_count.advisor_managed_count).toLocaleString('en-US')}})</span>
      </div>
      <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == 'MAGI' }" (click)="tabChange('MAGI')" >
        <span>MAGI ({{(tab_details_count.agi_count).toLocaleString('en-US')}})</span>
      </div> -->
    <ng-container *ngIf="user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14">
      <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == user_details.role.role_name + ' Managed' }" (click)="tabChange(user_details.role.role_name + ' Managed')" >
        <span>{{user_details.role.role_name}} Managed ({{getFormattedNumber(tab_details_count.advisor_managed_count)}})</span>
      </div>
      <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == 'MAGI' }" (click)="tabChange('MAGI')" >
        <span>MAGI ({{getFormattedNumber(tab_details_count.agi_count)}})</span>
      </div>
    </ng-container>
    <ng-container *ngIf="user_details.role.role == 8 || user_details.role.role == 13 || user_details.role.role == 14">
      <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == 'MAGI' }" (click)="tabChange('MAGI')" >
        <span>MAGI ({{getFormattedNumber(tab_details_count.agi_count)}})</span>
      </div>
      <!-- <div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == user_details.role.role_name + ' Managed' }" (click)="tabChange(user_details.role.role_name + ' Managed')" >
        <span>{{user_details.role.role_name}} Managed ({{(tab_details_count.advisor_managed_count).toLocaleString('en-US')}})</span>
      </div> -->
    </ng-container>
	</div>


  <ng-container *ngIf="tab_details_loaded">
    <ng-container *ngIf="user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14">
      <ng-container *ngIf="selected_tab == user_details.role.role_name + ' Managed'">
        <ng-container *ngIf="business_plan_loaded && stepper_details_loaded">

          <!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients'"> -->
          <!-- <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
          <!-- <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <!-- <ng-container *ngIf="type == 'Non Customers'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <ng-container>
            <!-- <app-stage-process-stepper [stepper_details]="stages_data" (stepperChange)="stepperChange($event)"></app-stage-process-stepper> -->
            <app-stage-process-stepper [stepper_stage]="selected_step_data" [stepper_details]="stages_data" (stepperChange)="stepperChange($event)"></app-stage-process-stepper>
          </ng-container>

          <ng-container *ngIf="stepper_count_data_loaded">

            <ng-container *ngIf="selected_step_data.position == 'overview'">

              <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'New Prospects'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
              <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Lending Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Insurance Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Non Customers'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="selected_step_data.position == 'first'">
              <!-- <app-opp-analysis [type]="type + ' Analysis'" [selected_opportunity_period]="selected_opportunity_period" [show_navigation]="false" [show_header]="false"></app-opp-analysis> -->
              <app-opp-analysis-v2 [type]="type + ' Analysis'" [selected_opportunity_period]="selected_opportunity_period" [show_navigation]="false" [show_header]="false"></app-opp-analysis-v2>
            </ng-container>

            <!-- <ng-container *ngIf="selected_step_data.position == 'first'">
              <ng-container *ngIf="type == 'Upside Opportunities'">
                <app-opportunity-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-opportunity-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Retention Opportunities'">
                <app-retention-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-retention-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Institutional Customers to Investment Clients'">
              <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
                <app-leads-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-leads-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'New Prospects'">
                <app-leads-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-leads-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'">
              <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Lending Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Insurance Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Non Customers'">
                <app-non-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-non-deposit-analysis>
              </ng-container>

            </ng-container> -->

            <ng-container *ngIf="(selected_step_data.position == 'middle' || selected_step_data.position == 'last')">
              <app-stage-process-view [type]="type" [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [selected_step_data]="selected_step_data"  [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-stage-process-view>
            </ng-container>

          </ng-container>

          <ng-container *ngIf="stepper_details_loaded && !stepper_count_data_loaded">
            <app-loader [loading_text]="'Loading Data'"></app-loader>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!stepper_details_loaded">
          <app-loader [loading_text]="'Loading Data'"></app-loader>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="selected_tab == 'MAGI'">
        <app-stage-process-view [type]="type + ' MAGI'" [stepper_stage]="selected_step_data" [selected_step_data]="selected_step_data"  [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-stage-process-view>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="user_details.role.role == 8 || user_details.role.role == 13 || user_details.role.role == 14">
      <ng-container *ngIf="business_plan_loaded && stepper_details_loaded">

          <!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients'"> -->
          <!-- <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
          <!-- <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <!-- <ng-container *ngIf="type == 'Non Customers'">
            <div class="business-plan-filter-section">
              <span class="business-plan-label">Select Business Plan</span>
              <mat-select class="business-plan-filter-input" [(ngModel)]="business_plan" (selectionChange)="businessPlanChange()">
                <mat-option [value]="0">All</mat-option>
                <mat-option *ngFor="let business_plan of business_plan_list" [value]="business_plan.id" >{{ business_plan.name }}</mat-option >
              </mat-select>
            </div>
          </ng-container> -->

          <ng-container>
            <!-- <app-stage-process-stepper [stepper_details]="stages_data" (stepperChange)="stepperChange($event)"></app-stage-process-stepper> -->
            <app-stage-process-stepper [stepper_stage]="selected_step_data" [stepper_details]="stages_data" (stepperChange)="stepperChange($event)"></app-stage-process-stepper>
          </ng-container>

          <ng-container *ngIf="stepper_count_data_loaded">

            <ng-container *ngIf="selected_step_data.position == 'overview'">

              <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'New Prospects'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
              <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Lending Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Insurance Clients'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>

              <ng-container *ngIf="type == 'Non Customers'">
                <app-deposits-overview [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposits-overview>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="selected_step_data.position == 'first'">
              <!-- <app-opp-analysis [type]="type + ' Analysis'" [selected_opportunity_period]="selected_opportunity_period" [show_navigation]="false" [show_header]="false"></app-opp-analysis> -->
              <app-opp-analysis-v2 [type]="type + ' Analysis'" [selected_opportunity_period]="selected_opportunity_period" [show_navigation]="false" [show_header]="false"></app-opp-analysis-v2>
            </ng-container>

            <!-- <ng-container *ngIf="selected_step_data.position == 'first'">
              <ng-container *ngIf="type == 'Upside Opportunities'">
                <app-opportunity-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-opportunity-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Retention Opportunities'">
                <app-retention-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-retention-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Institutional Customers to Investment Clients'">
              <ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
                <app-leads-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-leads-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'New Prospects' && user_details.role.business_area[0] == 5">
                <app-leads-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-leads-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'New Prospects' && user_details.role.business_area[0] != 5">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'">
              <ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Lending Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Bank Customers to Insurance Clients'">
                <app-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-deposit-analysis>
              </ng-container>

              <ng-container *ngIf="type == 'Non Customers'">
                <app-non-deposit-analysis [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [type]="type" [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-non-deposit-analysis>
              </ng-container>

            </ng-container> -->

            <ng-container *ngIf="(selected_step_data.position == 'middle' || selected_step_data.position == 'last')">
              <app-stage-process-view [type]="type" [selected_tab]="selected_tab" [stepper_stage]="selected_step_data" [selected_step_data]="selected_step_data"  [business_plan]="business_plan" [selected_opportunity_period]="selected_opportunity_period" (stepperChange)="stepperChange($event)"></app-stage-process-view>
            </ng-container>

          </ng-container>

          <ng-container *ngIf="stepper_details_loaded && !stepper_count_data_loaded">
            <app-loader [loading_text]="'Loading Data'"></app-loader>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!stepper_details_loaded">
          <app-loader [loading_text]="'Loading Data'"></app-loader>
        </ng-container>
    </ng-container>

  </ng-container>

	<ng-container *ngIf="!tab_details_loaded">
		<app-loader [loading_text]="'Loading Data'"></app-loader>
	</ng-container>

</div>


<ng-template #salesFunnelModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Sales Funnel</span>
			<span class="page-modal-close-icon" (click)="closeSalesFunnelModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<ng-cotainer *ngIf="sales_funnel_data_loaded">
				<div #salesFunnelContainer></div>
			</ng-cotainer>
			<ng-cotainer *ngIf="!sales_funnel_data_loaded">
				<app-loader [loading_text]="'Loading Funnel'"></app-loader>
			</ng-cotainer>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeSalesFunnelModal()">Close</button>
		</div>
	</div>
</ng-template>

<ng-template #agentFlowModal>
	<div class="page-modal-section" style="width: 1100px;">
		<div class="page-modal-heading-section">
			<!-- <span>Agentic Flow</span> -->
			<span>Agentic AI Workflow</span>
			<span class="page-modal-close-icon" (click)="closeAgentFlowModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<app-agentic-flow [type]="type"></app-agentic-flow>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeAgentFlowModal()">Close</button>
		</div>
	</div>
</ng-template>
